import SeoMeta from './SeoMeta';

export default SeoMeta;
